/* istanbul ignore file */
import { Box } from '@mui/material';

const Indent = () => <Box mt={1.5} />;

export default Indent;
